import type { BaseBlock } from "@/react/components/shared/BuilderUI/DataModel.types";
import type { LayoutElement } from "@/react/types/Element";

import { defaultData } from "./FormStackBlockDefaultData";

export const elementToBlock = (element: LayoutElement): BaseBlock => {
  const styles = element.attributes.styles || {};
  const defaultStyles = defaultData.props.styles?.value || {};

  return {
    id: element.id.toString(),
    type: "FormStackBlock",
    props: {
      children: {
        prop: "children",
        type: "children",
        value: [], // Children will be populated by the converter
      },
      styles: {
        prop: "styles",
        type: "styles",
        value: {
          ...defaultStyles,
          ...styles,
        },
      },
    },
    meta: {
      elementType: "layout",
      layoutType: element.attributes.layout_type,
      elementId: element.id,
      position: element.position,
      elementableId: element.elementable_id,
      parentElementId: element.parent_element_id,
    },
  };
};
